<template>
  <div class="tw-flex">
    <WdsButtonGhost v-if="count > 0" secondary :href="href" class="-tw-mx-1" :data-test="dataTest">
      {{ $tc(':count placement | :count placements', count) }}
    </WdsButtonGhost>
    <WdsText v-else secondary :data-test="dataTest">
      {{ emptyText ?? $t('No placements yet') }}
    </WdsText>
  </div>
</template>

<script setup lang="ts">
import { WdsButtonGhost, WdsText } from '@worksome/wds-components'
import { $t, $tc } from '@/app-bootstrapping/SetUpInternationalization'

defineProps<{ count: number; href: string; emptyText?: string; dataTest?: string }>()
</script>
